import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Composant Google Analytics
 * Remplacer 'G-XXXXXXXXXX' par votre ID de mesure Google Analytics
 */
const Analytics = () => {
  const location = useLocation();
  
  // ID Google Analytics (à remplacer par le vrai ID du client)
  const GA_MEASUREMENT_ID = 'G-XXXXXXXXXX';

  useEffect(() => {
    // Charger le script Google Analytics
    if (!window.gtag) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;
      
      gtag('js', new Date());
      gtag('config', GA_MEASUREMENT_ID, {
        page_path: location.pathname + location.search,
      });
    }
  }, []);

  useEffect(() => {
    // Tracker les changements de page
    if (window.gtag) {
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
};

/**
 * Google Tag Manager Component
 * Remplacer 'GTM-XXXXXXX' par votre ID Google Tag Manager
 */
export const GTM = () => {
  const GTM_ID = 'GTM-XXXXXXX';

  useEffect(() => {
    // Google Tag Manager
    (function(w,d,s,l,i){
      w[l]=w[l]||[];
      w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
      var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
      j.async=true;
      j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
      f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer',GTM_ID);
  }, []);

  return (
    <noscript>
      <iframe 
        src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
        height="0" 
        width="0" 
        style={{display:'none',visibility:'hidden'}}
        title="Google Tag Manager"
      ></iframe>
    </noscript>
  );
};

export default Analytics;
